import type { UserQuestionAnswerPair } from "./AskUserQuestion";

/** True when the user affirmed switching into Allow edits via an ask_user_question prompt. */
export function userQuestionAnswerAffirmsAllowEditsSwitch(pairs: UserQuestionAnswerPair[]): boolean {
  for (const { question, answer } of pairs) {
    const q = question.trim().toLowerCase();
    const a = answer.trim().toLowerCase();
    if (!q || !a) continue;

    const asksModeSwitch =
      /switch/.test(q)
      && (/allow edits|allow edit|write mode|editing mode|edit mode/.test(q) || /mode/.test(q));
    if (!asksModeSwitch) continue;

    const declines =
      /^(no\b|nope\b|don't\b|do not\b|stay\b|remain\b|chat only\b|chat-only\b)/.test(a)
      || /\b(stay in chat|chat only|chat-only|no switch|don't switch|do not switch)\b/.test(a);
    if (declines) continue;

    const affirms =
      /^(yes\b|yep\b|sure\b|ok\b|okay\b|proceed\b|go ahead\b|switch\b)/.test(a)
      || /\b(yes,? switch|switch and|allow edits|enable edits|use allow edits)\b/.test(a);
    if (affirms) return true;
  }
  return false;
}
